import React, { ReactElement } from 'react';
import {
    SettingType, FeatureType, AnyLayoutElement,
} from '@appblocks/codegeneration/types';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import TibbitsData from '@appblocks/platforms/TibbitDefinitions/tibbits.json';
import tibbitDiagrams from '@appblocks/codegeneration/tibbitDiagrams';

export default class BaseTibbit extends BaseFeature {
    constructor(tibbit_id: string = '') {
        super();
        this.singleInstance = false;
        this.featureType = FeatureType.TIBBIT;
        const settings = [
            {
                id: 'SOCKET',
                name: 'Socket',
                settingType: SettingType.HIDDEN,
                readonly: true,
                required: true,
                default: '',
            },
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.HIDDEN,
                readonly: true,
                required: true,
                default: '',
            },
            {
                id: 'PLATFORM',
                name: 'Platform',
                settingType: SettingType.HIDDEN,
                required: true,
                default: '',
            },
        ];
        this.settings = this.settings.concat(settings);
    }

    setSettingValue(settingId: string, settingValue: string) {
        super.setSettingValue(settingId, settingValue);
        if (settingId === 'SOCKET' || settingId === 'TIBBIT') {
            // this.setSettingValue(
            //    'NAME',
            //    `TIB_${this.getSettingValue('TIBBIT')}_SOCK_${this.getSettingValue('SOCKET')}`);
            const tibbit = this.getSettingValue('TIBBIT');
            const socket = this.getSettingValue('SOCKET');
            if (tibbit === '' || socket === '') {
                return;
            }
            const tibbitName = `T${this.getSettingValue('TIBBIT')}_S${this.getSettingValue('SOCKET')}`;
            for (let i = 0; i < this.settings.length; i += 1) {
                if (this.settings[i].settingType === SettingType.NAME) {
                    const newName = (`${tibbitName}_${this.settings[i].id}`).replace('_NAME', '').replace('NAME', '');
                    if (this.settings[i].value === '') {
                        this.setSettingValue(this.settings[i].id, newName);
                    }
                }
            }
        }
    }

    getDetails(): string {
        const baseURL = 'https://docs.tibbo.com';
        const tibbitNo = this.getSettingValue('TIBBIT');
        let tibbitURL = tibbitNo;
        const parts = tibbitURL.split('_');
        // for (let i = 0; i < parts.length; i++) {
        //     if (parts[i][0] == '0') {
        //         parts[i] = parts[i][1];
        //     }
        // }
        tibbitURL = parts.join('_');
        tibbitURL = tibbitURL.replace('_', '-');
        switch (tibbitNo) {
            // case '38':
            //     return `${baseURL}/38_c1_pushbutton`;
            case '39_1':
            case '39_2':
            case '39_3':
            case '39_4':
                return `${baseURL}/tibbit_39`;
            case '40_1':
            case '40_2':
            case '40_3':
            case '40_4':
                return `${baseURL}/tibbit_40`;
            default:
                return `${baseURL}/tibbit_${tibbitURL}`;
        }
    }

    getTibbit(tibbitId: string): any {
        for (let i = 0; i < TibbitsData.length; i += 1) {
            if (TibbitsData[i].good.model === tibbitId) {
                return TibbitsData[i];
            }
        }
        return undefined;
    }

    getTibbitDiagram(tibbitId: string): any {
        return tibbitDiagrams[tibbitId];
    }

    getDocURL(): string {
        const baseURL = 'https://docs.tibbo.com';
        const tibbitNo = this.getSettingValue('TIBBIT');
        let tibbitURL = tibbitNo;
        const parts = tibbitURL.split('_');
        // for (let i = 0; i < parts.length; i++) {
        //     if (parts[i][0] == '0') {
        //         parts[i] = parts[i][1];
        //     }
        // }
        tibbitURL = parts.join('_');
        tibbitURL = tibbitURL.replace('_', '-');
        switch (tibbitNo) {
            // case '38':
            //     return `${baseURL}/38_c1_pushbutton`;
            case '39_1':
            case '39_2':
            case '39_3':
            case '39_4':
                return `${baseURL}/tibbit_39`;
            case '40_1':
            case '40_2':
            case '40_3':
            case '40_4':
                return `${baseURL}/tibbit_40`;
            case '45_1':
            case '45_2':
            case '45_3':
                return `${baseURL}/tibbit_45`;
            default:
                return `${baseURL}/tibbit_${tibbitURL}`;
        }
    }
}
